module.exports = __webpack_public_path__ + "img/cart_icon.eda9f94e.svg";